import { responsiveBreakpointsPx } from '@/constants/responsiveness';
import styles from './responsiveImage.module.scss';
import cn from 'classnames';

export interface ResponsiveImage {
    source?: string;
    altText?: string;
}

export interface ResponsiveImageProps {
    desktop?: ResponsiveImage;
    mobile?: ResponsiveImage;
    tablet?: ResponsiveImage;
    loading?: 'eager' | 'lazy';
    fetchPriority?: 'high' | 'low' | 'auto';
    className?: string;
}

export function ResponsiveImage({
    desktop,
    mobile,
    tablet,
    loading = 'lazy',
    fetchPriority = 'auto',
    className,
}: ResponsiveImageProps): React.JSX.Element {
    const hasDesktopOrTabletImage = !!(desktop?.source || tablet?.source);
    const hasDesktopImageOnly = !!(desktop?.source && !mobile?.source && !tablet?.source);
    const hasTabletImageOnly = !!(tablet?.source && !mobile?.source && !desktop?.source);

    const pictureClasses = cn(styles.picture, className, {
        [styles.mobileOnly]: !hasDesktopOrTabletImage,
        [styles.desktopOnly]: hasDesktopImageOnly,
        [styles.tabletOnly]: hasTabletImageOnly,
    });

    return (
        <picture className={pictureClasses}>
            {desktop?.source && (
                <source srcSet={desktop.source} media={`(min-width: ${responsiveBreakpointsPx.lg}px)`} />
            )}
            {tablet?.source && <source srcSet={tablet.source} media={`(min-width: ${responsiveBreakpointsPx.md}px)`} />}
            <img
                src={mobile?.source || tablet?.source || desktop?.source}
                alt={mobile?.altText || tablet?.altText || desktop?.altText || ''}
                loading={loading}
                fetchPriority={fetchPriority}
            />
        </picture>
    );
}
